import {
  GET_LIST_DONGTIENNHANH,
  GET_LIST_DONGTIENNHANH_SUCCESS,
  GET_LIST_DONGTIENNHANH_FAILURE,
} from "./actionTypes";

export const getListDongTienNhanh = (dataSearch) => ({
  type: GET_LIST_DONGTIENNHANH,
  dataSearch,
});

export const getListDongTienNhanhSuccess = (data) => ({
  type: GET_LIST_DONGTIENNHANH_SUCCESS,
  payload: data,
});

export const getListDongTienNhanhFailure = () => ({
  type: GET_LIST_DONGTIENNHANH_FAILURE,
});
